import { useAuth } from "react-oidc-context";
import { useEmployeeUserProfile } from "@medoma/models/employeeUserProfile";

export const useUserProfile = () => {
  const { user } = useAuth();
  return useEmployeeUserProfile(user);
};
